export type TooltipMessageTemplateProps = {
	message: string;
	testId: string;
	useDescriptionStyle?: boolean;
}

export const TooltipMessageTemplate = ({
    message,
    testId,
    useDescriptionStyle = false
}: TooltipMessageTemplateProps) => {
    const DESCRIPTION_STYLE = { fontStyle: 'italic' };
    const descriptionStyle = useDescriptionStyle ? DESCRIPTION_STYLE : undefined;
    return (
        <p
            data-testid={testId}
            style={descriptionStyle}
        >
            {message}
        </p>
    );
};
